import * as React from 'react';
import { Tabber } from '../../../../designSystem/Tabber';
import { useHistory } from 'react-router-dom';

type ArticlesTabProps =
    {
        selectedTab: 'articles' | 'subscribers' | 'configuration' | 'followup' | 'retsinfo';
    };
export function ArticlesTab (props: ArticlesTabProps): JSX.Element
{
    const history = useHistory();

    function handleTabChange (tab: string)
    {
        if (tab === 'articles')
            history.push('/amorgy/articles');
        else if (tab === 'subscribers')
            history.push('/amorgy/articles/subscribers');
        else if (tab === 'configuration')
            history.push('/amorgy/articles/configuration');
        else if (tab === 'followup')
            history.push('/amorgy/articles/followup');
        else if (tab === 'retsinfo')
            history.push('/amorgy/articles/retsinfo');
        else
            throw new Error('Not implemented');
    }

    return (
        <Tabber
            variant='text'
            inline
            onClick={handleTabChange}
            selectedTabName={props.selectedTab}
            items={[
                {
                    tabName: 'articles',
                    text: 'Lovkrav'
                },
                {
                    tabName: 'subscribers',
                    text: 'Abonnenter'
                },
                {
                    tabName: 'configuration',
                    text: 'Opsætning'
                },
                {
                    tabName: 'followup',
                    text: 'Opfølgning'
                },
                {
                    tabName: 'retsinfo',
                    text: 'Retsinformation'
                }
            ]}
        />
    );
}